export default __webpack_public_path__ + "static/media/button 52x52 - stroke.7c90d990.png";